import { SmartStorage } from 'smart-core-util'
let Uris = SmartStorage.get("Uris")
export const baseUrl = {
    iWaimaiUrl: Uris.Uris['webapp-iwaimai'],
    iShopUrl: Uris.Uris['webapp-ishop'],
    smartalipay: Uris.Uris.gateway,
    'engine-api': Uris.Uris.gateway
}